export const messages = {
  en: {
    changeLocale: '中文',
    switch: 'Switch',
    name: 'Group Platform',
    router: {
      home: 'Home',
      school: 'School',
      manage: 'Management',
      distributorMgmt: 'Distributor Management',
      addDistributor: 'Add Distributor',
      editDistributor: 'Edit Distributor',
      viewDistributor: 'View Distributor',
      schoolMgmt: 'School Management',
      viewSchool: 'View School',
      staffMgmt: 'Staff Management',
      viewStaff: 'View Staff',
      resource: 'Teaching Resources',
      assessmentFrame: 'Assessment Framework',
      addAssessmentSheet: 'Add Assessment Sheet',
      editAssessmentSheet: 'Edit Assessment Sheet',
      viewAssessmentSheet: 'View Assessment Sheet',
      mibp: 'MI Bilingual Programme',
      mibpMgmt: 'MIBP Management',
      mibpDetail: 'Book Detail',
      mibpSubscribe: 'Subscribe Detail',
      phdCourse: 'PHD',
      phdCourseDetail: 'Course Detail',
      personal: 'Personal',
      systemMessage: 'System Message',
    },
    login: {
      accountLogin: 'Account Login',
      emailTitle: 'Contact email',
      enterAccount: 'Please enter account!',
      enterAccountPlaceholder: 'Please enter account',
      enterMobile: 'Please enter mobile phone number!',
      enterMobilePlaceholder: 'Enter mobile phone number',
      enterPassword: 'Please enter password!',
      enterPasswordPlaceholder: 'Enter password',
      enterVerifyCode: 'Please enter verify code!',
      enterVerifyCodePlaceholder: 'Enter verify code',
      login: 'Login',
      loginAuto: 'Automatic login within 7 days',
      mobileLogin: 'Mobile Login',
      resendVerifyCode: 'Reacquire after {timer}s',
      sendVerifyCode: 'Get verify code',
      sendVerifyCodeFail: 'Verify code sending failed',
      sendVerifyCodeSuccess: 'Verify code sent successfully',
      systemName: 'Skill Assessment and Teaching Management System',
      forgetPassword: 'Forget Password?',
      resetSuccessTip:
        'A password reset verification has been sent to your email address {email}. Please login with the modified password.',
      retrievePassword: 'Retrieve Password',
      next: 'Next',
      backToLogin: 'Back to login',
      setNewPassword: 'Set new password',
      enterNewPassword: 'Please enter new password',
      enterNewPasswordAgain: 'Please enter again',
      passwordNotEqual: 'The two passwords you typed do not match',
      resetPasswordSuccess: 'Modify Password Successfully',
      backAfterSeconds:
        'Back to login after {second} second | Back to login after {second} seconds',
      goToLogin: 'Go to login ({second})',
    },
    common: {
      add: 'Add',
      attention: 'Attention',
      cancel: 'Cancel',
      complete: 'Complete',
      confirm: 'Confirm',
      delete: 'Delete',
      edit: 'Edit',
      freeze: 'Freeze',
      enable: 'Enable',
      save: 'Save',
      resetPassword: 'Reset Password',
      deleteSuccess: 'Delete successfully',
      editSuccess: 'Edit successfully',
      freezeSuccess: 'Freeze successfully',
      enableSuccess: 'Enable successfully',
      saveSuccess: 'Save successfully',
      resetSuccess: 'Reset successfully',
      name: 'Name',
      operations: 'Operations',
      reset: 'Reset',
      quit: 'Quit',
      next: 'Next',
      back: 'Back',
      upload: 'Upload',
      uploadSuccess: 'Upload successfully',
      all: 'All',
      reserveEdit: 'Edit will not be retained after exit. Confirm to exit?',
      enterContent: 'Enter content',
      school: 'School',
      resetPasswordConfirm:
        'This member can use the default password to login after reset, are you sure to reset?',
      selectAll: 'Select All',
      download: 'Download',
      disable: 'Disable',
      disableSuccess: 'Disabled successfully',
      expand: 'Expand',
      collapse: 'Collapse',
    },
    distributorMgmt: {
      distributorInfo: 'Distributor Info',
      featureSetting: 'Feature Setting',
      enterDistributorName: 'Enter distributor name',
      enterLoginEmail: 'Enter login email',
      enterCorrectEmail: 'Please enter correct email',
      enterContact: 'Enter contact',
      enterAddress: 'Enter contact address',
      enterBrief: 'Enter brief',
      distributorName: 'Distributor Name',
      loginEmail: 'Login Email',
      emailTip: "This email will be used as the distributor's login account",
      email: 'Email',
      contact: 'Contact',
      address: 'Address',
      schoolNum: 'School Number',
      status: 'Status',
      creationDate: 'Creation Date',
      creator: 'Creator',
      contract: 'Contract',
      brief: 'Brief',
      uploadAttachment: 'Upload Attachment',
      featureInfo: 'Feature Info',
      assessmentFramework: 'Assessment Framework',
      freezeConfirm:
        'After frozen, the distributor cannot log in, but the school under it will not be frozen. Are you sure to freeze this distributor?',
      enableConfirm: 'Are you sure to enable this distributor?',
      deleteConfirm:
        "After deletion, this distributor can't be restore. Are you sure to delete it?",
      deleteFailTip:
        'There are still schools under this distributor. Please delete them before deleting this distributor',
      attachmentLimit: 'The size of a single attachment is limited to 100M',
      mibp: 'MIBP',
      section: 'Section',
      bookSeries: 'Book Series',
      subscribedNum: 'Subscribed Number',
      school: 'School',
      distributorTotal:
        'A total of 0 distributors | A total of 1 distributor | A total of {total} distributors',
      noAssessTip:
        'There is no need to set up assement framework without providing the assessment feature to this distributor',
      invalidFileSize: 'A single attachment cannot exceed 100M',
      invalidFileFormat: 'Only accept files with suffix of doc, docx, pdf, jpg, jpeg and png',
      selectFrame: 'Select assessment frame',
      addDistributorSuccess: 'Add new distributor successfully',
      cannotDelete:
        'This distributor still owns school. Please delete school before deleting the distributor',
      distributorNameLimit: 'Distributor name cannot exceed 100 characters',
      emailLimit: 'Email cannot exceed 100 characters',
      contactLimit: 'Contact cannot exceed 100 characters',
      addressLimit: 'Address cannot exceed 500 characters',
      briefLimit: 'Introduction cannot exceed 500 characters',
      usedFrame:
        '{frame} have been used, you cannot remove it. | {frame} has been used, you cannot remove it. | {frame} have been used, you cannot remove it.',
    },
    schoolMgmt: {
      enterSchoolName: 'Enter school name',
      selectDistributor: 'Select distributor',
      schoolCode: 'School Code',
      schoolName: 'School Name',
      distributor: 'Distributor',
      school: 'School',
      abbreviation: 'Abbreviation',
      address: 'Address',
      contact: 'Contact',
      brief: 'Brief',
      nature: 'Nature',
      adminAccount: 'School Admin Account',
      adminName: 'Admin Chinese Name',
      adminEnName: 'Admin English Name',
      openSchoolYear: 'Open School Year',
      status: 'Status',
      teacherNum: 'Teachers',
      studentNum: 'Students',
      creationDate: 'Creation Date',
      freezeConfirm: 'Are you sure to freeze this school?',
      enableConfirm: 'Are you sure to enable this school?',
      deleteConfirm: "After deletion, this school can't be restore. Are you sure to delete it?",
      section: 'Section',
      schoolAdmin: 'School Admin',
      ownedDistributor: 'Owned Distributor',
      featureInfo: 'Feature Info',
      assessmentFramework: 'Assessment Framework',
      classNum: 'Classes',
      parentNum: 'Parents',
      basicInfo: 'Basic Info',
      schoolInfo: 'School Info',
      mibp: 'MIBP',
      bookSeries: 'Book Series',
      subscribedNum: 'Subscribed Number',
      schoolTotal: 'A total of 0 schools | A total of 1 school | A total of {total} schools',
      moments: 'Moments',
      sharedMoments: 'Moments Shared',
      momentsWithSkills: 'Moments with Skills',
      likes: 'Likes',
    },
    staffMgmt: {
      role: 'Role',
      rolePlaceholder: 'Please select role',
      staffTotal: 'A total of 0 staffs | A total of 1 staff | A total of {total} staffs',
      roleType: {
        '1404': 'Administrator',
        '1405': 'Staff',
      },
      addStaff: 'Add staff',
      editStaff: 'Edit staff',
      loginEmail: 'Login Email',
      enterLoginEmail: 'Enter login email',
      enterCorrectEmail: 'Please enter correct email',
      deleteConfirm: 'Confirm deleting all records related to this staff?',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      confirmResetPassword:
        'The staff can use the default password to login after reset, are you sure to reset?',
      account: 'Account',
      password: 'Password',
      emptyName: 'You must fill either Chinese name or English name',
      zhName: 'Chinese Name',
      enName: 'English Name',
      zhNameInvalid: 'Your Chinese name should be within 50 characters in length',
      enNameInvalid: 'Your English name should be within 50 characters in length',
      enterZhName: 'Enter Chinese name',
      enterEnName: 'Enter English name',
      admin: 'Administrators',
      staff: 'Staff',
      enterName: 'Please enter name',
      selectRole: 'Please select role',
    },
    personal: {
      personalInfo: 'Personal Information',
      accountSetting: 'Account Setting',
      avatar: 'Avatar',
      modifyAvatar: 'Modify avatar',
      zhName: 'Chinese name',
      enName: 'English name',
      zhNamePlaceholder: 'Please enter Chinese name (1-50 characters)',
      enNamePlaceholder: 'Please enter English name (1-50 characters)',
      email: 'E-mail',
      emailPlaceholder: 'Please enter email',
      enterEmail: 'Please enter email',
      emailLimit: 'The email length cannot exceed 100 characters',
      enterCorrectEmail: 'Please enter correct email',
      account: 'Account',
      password: 'Password',
      modifyPassword: 'Modify password',
      save: 'Save',
      uploadAvatar: 'Click to upload avatar',
      avatarLimit: 'Support JPG, PNG format of the picture, the size of no more than 2M',
      cropTip:
        'Zoom Mouse wheel to control image display size, drag and adjust the position of the image',
      preview: 'Preview',
      reupload: 'Reupload',
      currentPassword: 'Current password',
      currentPasswordPlaceholder: 'Please enter current password',
      newPassword: 'New password',
      newPasswordPlaceholder: 'Please enter new password',
      repeatPassword: 'Repeat password',
      repeatPasswordPlaceholder: 'Please repeat new password',
      wrongAvatar: 'Please upload avatar in correct format!',
      wrongBrowser:
        'Sorry, the current browser does not support uploading avatars, please try again with a new browser',
      modifySuccess: 'Modify successfully',
      passwordLimit: 'The password must be a combination of 8-20 characters, letters and Numbers',
      wrongPassword: 'Different passwords!',
      nameInvalid: 'Name Invalid.',
    },
    mibp: {
      pictureBook: 'Picture Book',
      suitableSection: 'Suitable Grade',
      bookNum: 'Book Number',
      subscribeNum: "Subscribers' Number",
      operateRecord: 'Operate Record',
      date: 'Date',
      name: 'Name',
      section: 'Grade',
      namePlaceholder: 'Please enter student name',
      student: 'Student',
      class: 'Class',
      operator: 'Operator',
      operateTime: 'Operate Time',
      openDate: 'Open Date',
      subscribeDetail: 'Subscribe Detail',
      subscribed: 'Subscribed',
      notSubscribed: 'Not Subscribed',
      batchStopSubscribe: 'Batch stop subscribe',
      batchBeginSubscribe: 'Batch begin subscribe',
      studentNum: '0 students | 1 student | {num} students',
      expand: 'Expand',
      collapse: 'Collapse',
      stopSubscribe: 'Stop Subscribe',
      beginSubscribe: 'Begin Subscribe',
      stopSuccess: 'Stop subscribe successfully',
      beginSuccess: 'Begin subscribe successfully',
      confirmStopSubscribe: 'Are you sure to stop subscribe?',
      confirmBeginSubscribe: 'Are you sure to begin subscribe?',
      open: 'Open at {time}',
      firstPage: 'Already the first page',
      lastPage: 'Already the last page',
      loading: 'Loading... {progress}',
      bookDetail: 'Book Detail',
      selectDate: 'Select Date',
      mibp: 'MIBP',
      has: "'s",
      file: 'File',
      deleteFile: 'Are you sure to delete this file?',
      bookName: 'Name',
      attachmentOverLimit: 'Only support uploading within 100M attachments',
      lessonPlans: 'Lesson Plans',
      monthlyReview: 'Monthly Review',
      studentBook: 'Student Book',
      uploadCorrectAttachment: 'Please upload attachment in correct format(.pdf)',
      appliedSchool: 'Applied School',
      selectSchool: 'Select school',
    },
    phdCourse: {
      phdCourse: 'PHD',
      suitableSection: 'Suitable Grade',
      courseNumber: 'Number of Course',
      courseOrder: 'Course Order',
      openDate: 'Open Date',
      has: "'s",
      materials: 'Materials',
      file: 'File',
      deleteFile: 'Are you sure to delete this file?',
      attachmentOverLimit: 'Only support uploading within 100M attachments',
      firstPage: 'Already the first page',
      lastPage: 'Already the last page',
      loading: 'Loading... {progress}',
      cover: 'Cover',
      catalog: 'Catalog',
      uploadCorrectAttachment: 'Please upload attachment in correct format(.pdf)',
    },
    assessmentFrame: {
      name: 'Name',
      section: 'Section',
      assessmentSheet: 'AssessmentSheet',
      skillNum: 'Skill Number',
      assessmentFrame: 'Assessment Frame',
      sheetName: 'Assessment Sheet Name',
      saveFirst: 'Please save assessment sheet info first',
      levelASkill: 'Level 1 Skill',
      levelBSkill: 'Level 2 Skill',
      levelCSkill: 'Level 3 Skill',
      addLevelASkill: 'Add Level 1 Skill',
      addLevelBSkill: 'Add Level 2 Skill',
      addLevelCSkill: 'Add Level 3 Skill',
      editLevelASkill: 'Edit Level 1 Skill',
      editLevelBSkill: 'Edit Level 2 Skill',
      editLevelCSkill: 'Edit Level 3 Skill',
      enterSheetName: 'Enter sheet name',
      sheetNameLimit: 'The number of sheet name cannot exceed 200 characters',
      selectSection: 'Select section',
      abbreviation: 'Abbreviation',
      noAbbreviation: 'Enter abbreviation',
      abbreviationLimit: 'The number of abbreviations cannot exceed 50 characters',
      rubrics: 'Rubrics',
      deleteLevelATip: 'Are you sure to delete this level 1 skill?',
      deleteLevelBTip: 'Are you sure to delete this level 2 skill?',
      deleteLevelCTip: 'Are you sure to delete this level 3 skill?',
      saveTipA: 'The assessment sheet requires at least one level 1 skill',
      saveTipB: 'The assessment sheet requires at least one level 2 skill',
      saveTipC: 'The assessment sheet requires at least one level 3 skill',
      deleteConfirm: 'Are you sure to delete this assessment sheet?',
      targetSection: 'Target Section',
      textLimit: 'Rubrics should not exceed 1000 characters',
      noLevelASkill: 'Enter Level 1 Skill',
      noLevelBSkill: 'Enter Level 2 Skill',
      noLevelCSkill: 'Enter Level 3 Skill',
      enable: 'Enable',
      disable: 'Disable',
      active: 'Active',
      inactive: 'Inactive',
      status: 'Status',
      deleteClassConfirm: 'Are you sure to delete this skill?',
      modifier: 'Modifier',
      modifyTime: 'Modify Date',
      emerging: 'Emerging',
      performing: 'Performing',
      mastering: 'Mastering',
      emerging1: 'Emerging1',
      emerging2: 'Emerging2',
      emerging3: 'Emerging3',
      performing4: 'Developing4',
      performing5: 'Developing5',
      performing6: 'Developing6',
      mastering7: 'Secure7',
      mastering8: 'Secure8',
      mastering9: 'Secure9',
      schoolYear: 'School Year',
      selectSchoolYear: 'Select school year',
    },
    operation: {
      9001: 'Stop Subscribe',
      9002: 'Begin Subscribe',
    },
    notFound: {
      notFound: 'Sorry, the page you visited does not exist.',
      backToHome: 'Back to Home',
    },
    clientFeature: {
      moment: 'Moments',
      comment: 'Comment Moment',
      parentMoment: 'Publish Moment (Parent)',
      assessment: 'Assess',
      assessmentSheet: 'Assessment Sheet',
      assessmentReport: 'Assessment Report',
      application: 'Apps',
      attendance: 'Attendance',
      dailyCare: 'Daily Cares',
      diary: 'Diaries',
      sketch: 'Sketch',
      recipe: 'Recipe',
      album: 'Class Album',
      calendar: 'School Calendar',
      leaveAudit: 'Leave Audit',
      mibp: 'MIBP',
      learningJournal: 'Learning Journal',
      phdCourse: 'PHD',
      message: 'Messages',
      replyMessage: 'Reply messages (Parent)',
      sendMessage: 'Send messages (Parent)',
    },
    noContent: {
      class: 'No Classes~',
    },
    statusConstant: {
      1220: 'Enabled',
      1221: 'Frozen',
      1230: 'Kindergarten',
      1231: 'Primary School',
    },
  },
  zh: {
    changeLocale: 'English',
    switch: '切换',
    name: '集团平台',
    router: {
      home: '首页',
      school: '学校',
      manage: '管理数据',
      distributorMgmt: '经销商管理',
      addDistributor: '新增经销商',
      editDistributor: '编辑经销商',
      viewDistributor: '查看经销商',
      schoolMgmt: '学校管理',
      viewSchool: '查看学校',
      staffMgmt: '人员管理',
      viewStaff: '查看人员',
      resource: '教学资源',
      assessmentFrame: '评估框架',
      addAssessmentSheet: '新增评估表',
      editAssessmentSheet: '编辑评估表',
      viewAssessmentSheet: '查看评估表',
      mibp: '多元智能双语课程',
      mibpDetail: '绘本详情',
      mibpSubscribe: '订阅详情',
      phdCourse: 'PHD',
      phdCourseDetail: '课程详情',
      personal: '个人中心',
      systemMessage: '系统消息',
    },
    login: {
      accountLogin: '账号密码登录',
      emailTitle: '联系邮箱',
      enterAccount: '请输入账号！',
      enterAccountPlaceholder: '请输入账号',
      enterMobile: '请输入手机号！',
      enterMobilePlaceholder: '请输入手机号',
      enterPassword: '请输入密码！',
      enterPasswordPlaceholder: '请输入密码',
      enterVerifyCode: '请输入验证码！',
      enterVerifyCodePlaceholder: '请输入验证码',
      login: '登录',
      loginAuto: '7天内自动登录',
      mobileLogin: '验证码登录',
      resendVerifyCode: '{timer}秒后重新获取',
      sendVerifyCode: '获取验证码',
      sendVerifyCodeFail: '验证码发送失败',
      sendVerifyCodeSuccess: '验证码发送成功',
      systemName: '素质评估与教学管理系统',
      forgetPassword: '忘记密码?',
      resetSuccessTip: '已向您的邮箱{email}发送重置密码验证，请使用修改后的密码进行登录',
      retrievePassword: '找回密码',
      next: '下一步',
      backToLogin: '返回登录页',
      setNewPassword: '设置新密码',
      enterNewPassword: '请输入新密码',
      enterNewPasswordAgain: '请再输入一遍',
      passwordNotEqual: '两次输入的密码不一致',
      resetPasswordSuccess: '修改密码成功',
      backAfterSeconds: '{second}秒后返回登录页',
      goToLogin: '去登录({second})',
    },
    common: {
      add: '新增',
      attention: '注 意',
      cancel: '取消',
      complete: '完成',
      confirm: '确定',
      delete: '删除',
      edit: '编辑',
      freeze: '冻结',
      enable: '启用',
      save: '保存',
      resetPassword: '重置密码',
      deleteSuccess: '删除成功',
      editSuccess: '编辑成功',
      freezeSuccess: '冻结成功',
      enableSuccess: '启用成功',
      saveSuccess: '保存成功',
      resetSuccess: '重置密码成功',
      name: '姓名',
      operations: '操作',
      reset: '重置',
      quit: '退出',
      next: '下一步',
      back: '返回',
      upload: '上传',
      uploadSuccess: '上传成功',
      all: '全部',
      reserveEdit: '退出后不会保留编辑内容，确认退出？',
      enterContent: '请输入内容',
      school: '学校',
      resetPasswordConfirm: '重置后该人员可以用默认密码登录，确定重置密码？',
      selectAll: '全选',
      download: '下载',
      disable: '停用',
      disableSuccess: '停用成功',
      expand: '展开',
      collapse: '收起',
    },
    distributorMgmt: {
      distributorInfo: '经销商信息',
      featureSetting: '功能设置',
      enterDistributorName: '请输入经销商名称',
      enterLoginEmail: '请输入登录邮箱',
      enterCorrectEmail: '请输入正确的邮箱',
      enterContact: '请输入联系方式',
      enterAddress: '请输入联系地址',
      enterBrief: '请输入简介',
      distributorName: '经销商名称',
      loginEmail: '登录邮箱',
      emailTip: '该邮箱将作为经销商的登录账号',
      email: '邮箱',
      contact: '联系方式',
      address: '联系地址',
      schoolNum: '学校数量',
      status: '状态',
      creationDate: '创建日期',
      creator: '创建人',
      contract: '合同',
      brief: '简介',
      uploadAttachment: '上传附件',
      featureInfo: '功能信息',
      assessmentFramework: '评估框架',
      freezeConfirm: '冻结经销商后经销商不可登录，但不会冻结名下学校，确认冻结？',
      enableConfirm: '确认启用经销商？',
      deleteConfirm: '删除后该经销商将无法启用，确认删除经销商？',
      deleteFailTip: '经销商下仍有启用的学校， 请先冻结学校再删除经销商',
      attachmentLimit: '单个附件大小限制100M以内',
      mibp: '多元智能双语课程',
      section: '年级',
      bookSeries: '绘本系列',
      subscribedNum: '订阅人数',
      school: '学校',
      distributorTotal: '共{total}家经销商',
      noAssessTip: '未给经销商开通评估功能，无需设置评估框架',
      invalidFileSize: '单个附件大小不能超过100M',
      invalidFileFormat: '仅接受后缀名为doc, docx, pdf, jpg, jpeg或png的文件',
      selectFrame: '请选择评估框架',
      addDistributorSuccess: '经销商新增成功',
      cannotDelete: '经销商下仍有学校，请先删除学校后再删除经销商',
      distributorNameLimit: '经销商名称不能超过100字',
      emailLimit: '邮箱不能超过100字',
      contactLimit: '联系方式不能超过100字',
      addressLimit: '联系地址不能超过500字',
      briefLimit: '简介不能超过500字',
      usedFrame: '{frame}已被学校使用，不能删除',
    },
    schoolMgmt: {
      enterSchoolName: '请输入学校名称',
      selectDistributor: '请选择经销商',
      schoolCode: '学校编号',
      schoolName: '学校名称',
      distributor: '经销商',
      school: '学校',
      abbreviation: '学校简称',
      address: '学校地址',
      contact: '联系电话',
      brief: '简介',
      nature: '学校性质',
      adminAccount: '学校管理员账号',
      adminName: '管理员中文名',
      adminEnName: '管理员英文名',
      openSchoolYear: '开启学年',
      status: '状态',
      teacherNum: '教师数量',
      studentNum: '学生数量',
      creationDate: '创建日期',
      freezeConfirm: '确认冻结学校？',
      enableConfirm: '确认启用学校？',
      deleteConfirm: '删除后该学校将无法启用，确认删除学校？',
      section: '年级',
      schoolAdmin: '学校管理员',
      ownedDistributor: '所属经销商',
      featureInfo: '功能信息',
      assessmentFramework: '评估框架',
      classNum: '班级数量',
      parentNum: '家长数量',
      basicInfo: '基本信息',
      schoolInfo: '学校信息',
      mibp: '多元智能双语课程',
      bookSeries: '绘本系列',
      subscribedNum: '订阅人数',
      schoolTotal: '共{total}所学校',
      moments: '成长记录',
      sharedMoments: '已分享的成长记录',
      momentsWithSkills: '与技能相关的成长记录',
      likes: '点赞数',
    },
    staffMgmt: {
      role: '角色',
      rolePlaceholder: '请选择角色',
      staffTotal: '共{total}位人员',
      roleType: {
        '1404': '管理员',
        '1405': '员工',
      },
      addStaff: '新增人员',
      editStaff: '编辑人员',
      loginEmail: '登录邮箱',
      enterLoginEmail: '请输入登录邮箱',
      enterCorrectEmail: '请输入正确的邮箱',
      deleteConfirm: '确定彻底删除该人员及其所有记录？',
      addSuccess: '新增成功',
      editSuccess: '编辑成功',
      confirmResetPassword: '重置后该人员可以用默认密码登录，确定重置密码？',
      account: '账号',
      password: '密码',
      emptyName: '中文名和英文名至少填写一个',
      zhName: '中文名',
      enName: '英文名',
      zhNameInvalid: '中文名长度应为1-50字符',
      enNameInvalid: '英文名长度应为1-50字符',
      enterZhName: '请输入中文名',
      enterEnName: '请输入英文名',
      admin: '管理员',
      staff: '员工',
      enterName: '请输入姓名',
      selectRole: '请选择角色',
    },
    personal: {
      personalInfo: '个人信息',
      accountSetting: '账户设置',
      avatar: '头像',
      modifyAvatar: '更换头像',
      zhName: '中文名',
      enName: '英文名',
      zhNamePlaceholder: '请输入中文名(1-50字符)',
      enNamePlaceholder: '请输入英文名(1-50字符)',
      email: '邮箱',
      emailPlaceholder: '请输入邮箱',
      enterEmail: '请输入邮箱',
      emailLimit: '邮箱长度不能超过100字符',
      enterCorrectEmail: '请输入正确的邮箱',
      account: '帐户',
      password: '密码',
      modifyPassword: '修改密码',
      save: '保存',
      uploadAvatar: '点击上传头像',
      avatarLimit: '支持jpg、png格式的图片，大小不超过2M',
      cropTip: '鼠标滚轮缩放控制图片显示大小，拖拽调整图片位置',
      preview: '预览',
      reupload: '重新上传',
      currentPassword: '当前密码',
      currentPasswordPlaceholder: '请输入当前密码',
      newPassword: '新密码',
      newPasswordPlaceholder: '请输入新密码',
      repeatPassword: '确认密码',
      repeatPasswordPlaceholder: '请确认密码',
      wrongAvatar: '请上传正确的头像！',
      wrongBrowser: '抱歉，当前浏览器暂不支持上传头像，请更换浏览器重试',
      modifySuccess: '修改成功',
      passwordLimit: '密码必须为8-20位，字母+数字的组合',
      wrongPassword: '两次输入的密码不一致！',
      nameInvalid: '中文名或英文名有误！',
    },
    mibp: {
      pictureBook: '绘本',
      suitableSection: '适用年级',
      bookNum: '绘本数量',
      subscribeNum: '订阅人数',
      operateRecord: '操作记录',
      date: '日期',
      name: '名称',
      namePlaceholder: '请输入学生名称',
      student: '学生',
      class: '班级',
      section: '年级',
      operator: '操作人',
      operateTime: '操作时间',
      openDate: '开启日期',
      subscribeDetail: '订阅详情',
      subscribed: '已订阅',
      notSubscribed: '未订阅',
      batchStopSubscribe: '批量停止订阅',
      batchBeginSubscribe: '批量开启订阅',
      studentNum: '{num}人',
      expand: '展开',
      collapse: '收起',
      stopSubscribe: '停止订阅',
      beginSubscribe: '开启订阅',
      stopSuccess: '停止订阅成功',
      beginSuccess: '开始订阅成功',
      confirmStopSubscribe: '确认停止订阅？',
      confirmBeginSubscribe: '确认开启订阅？',
      open: '{time}开启',
      firstPage: '已经是第一页',
      lastPage: '已经是最后一页',
      loading: '加载中... {progress}',
      bookDetail: '绘本详情',
      selectDate: '选择日期',
      mibp: 'MI绘本教案及活动',
      has: '的',
      file: '文件',
      deleteFile: '确定要删除这个文件吗？',
      bookName: '绘本名称',
      attachmentOverLimit: '仅支持上传100M以内附件',
      lessonPlans: '教案',
      monthlyReview: '月度概览',
      studentBook: '练习册',
      uploadCorrectAttachment: '请上传正确格式的附件(.pdf)',
      appliedSchool: '应用学校',
      selectSchool: '请选择学校',
    },
    phdCourse: {
      phdCourse: 'PHD',
      suitableSection: '适用年级',
      courseNumber: '课程数量',
      courseOrder: '课程顺序',
      openDate: '开启日期',
      has: '的',
      materials: '教学素材',
      file: '文件',
      deleteFile: '确定要删除这个文件吗？',
      attachmentOverLimit: '仅支持上传100M以内附件',
      firstPage: '已经是第一页',
      lastPage: '已经是最后一页',
      loading: '加载中... {progress}',
      cover: '封面',
      catalog: '目录',
      uploadCorrectAttachment: '请上传正确格式的附件(.pdf)',
    },
    assessmentFrame: {
      section: '年级',
      assessmentSheet: '评估表',
      skillNum: '技能数',
      assessmentFrame: '评估框架',
      sheetName: '评估表名称',
      saveFirst: '请先保存评估表信息',
      levelASkill: '一级技能',
      levelBSkill: '二级技能',
      levelCSkill: '三级技能',
      addLevelASkill: '添加一级技能',
      addLevelBSkill: '添加二级技能',
      addLevelCSkill: '添加三级技能',
      editLevelASkill: '编辑一级技能',
      editLevelBSkill: '编辑二级技能',
      editLevelCSkill: '编辑三级技能',
      enterSheetName: '请输入评估表名称',
      sheetNameLimit: '评估表名称字数不能超过200字符',
      selectSection: '请选择年级',
      abbreviation: '缩写',
      noAbbreviation: '请输入缩写',
      abbreviationLimit: '缩写字数不能超过50个字符',
      rubrics: '说明',
      deleteLevelATip: '确认删除这个一级技能吗？',
      deleteLevelBTip: '确认删除这个二级技能吗？',
      deleteLevelCTip: '确认删除这个三级技能吗？',
      saveTipA: '评估表需要有至少一个一级技能',
      saveTipB: '评估表需要有至少一个二级技能',
      saveTipC: '评估表需要有至少一个三级技能',
      deleteConfirm: '确定删除评估表？',
      targetSection: '应用年级',
      textLimit: '说明不能超过1000字',
      noLevelASkill: '请输入一级技能',
      noLevelBSkill: '请输入二级技能',
      noLevelCSkill: '请输入三级技能',
      enable: '启用',
      disable: '禁用',
      active: '启用',
      inactive: '停用',
      status: '状态',
      deleteClassConfirm: '确认要删除该技能吗？',
      modifier: '修改人',
      modifyTime: '修改时间',
      emerging: '加油',
      performing: '达标',
      mastering: '超出',
      emerging1: '加油1',
      emerging2: '加油2',
      emerging3: '加油3',
      performing4: '达标4',
      performing5: '达标5',
      performing6: '达标6',
      mastering7: '超出7',
      mastering8: '超出8',
      mastering9: '超出9',
      schoolYear: '学年',
      selectSchoolYear: '请选择学年',
    },
    operation: {
      9001: '停止订阅',
      9002: '开启订阅',
    },
    notFound: {
      notFound: '抱歉，您访问的页面不存在。',
      backToHome: '返回首页',
    },
    clientFeature: {
      moment: '成长记录',
      comment: '评论成长记录',
      parentMoment: '发布成长记录（家长端）',
      assessment: '评估',
      assessmentSheet: '评估表',
      assessmentReport: '评估报告',
      application: '应用',
      attendance: '考勤',
      dailyCare: '生活记录',
      sketch: '画板',
      recipe: '食谱',
      diary: '日记簿',
      album: '班级相册',
      calendar: '校历',
      leaveAudit: '请假审批',
      mibp: '多元智能双语课程',
      learningJournal: '学习日志',
      phdCourse: 'PHD',
      message: '消息通知',
      sendMessage: '发消息（家长端）',
      replyMessage: '回复消息（家长端）',
    },
    noContent: {
      class: '暂无班级~',
    },
    statusConstant: {
      1220: '启用',
      1221: '冻结',
      1230: '幼儿园',
      1231: '小学',
    },
  },
}

export const dateTimeFormats = {
  en: {
    month: {
      year: 'numeric',
      month: 'short',
    },
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  zh: {
    month: {
      year: 'numeric',
      month: 'short',
    },
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    },
  },
}
